import { contentTypes } from 'ggApp/modules/contentful/models/contentTypes';
import { mapCfEntity } from './mapper';

export class CfProductDetailPage {
    static pageName = 'ProductDetailsPage';

    static mapCfEntry = mapCfEntity;

    static get config() {
        return {
            contentType: contentTypes.CfProductDetailPage,
            filters: {
                'fields.insuranceType': 'GroverCare',
            },
        };
    }

    constructor(props = {}) {
        const { faqList, uspCards, tooltipText, benefitList } = props;
        this.data = { faqList, uspCards, tooltipText, benefitList };
    }
}
